/**
 * True when an error is Dexie's `DatabaseClosedError` — the connection was shut
 * out from under an in-flight read/write. Expected during the deliberate
 * logout/reset path (the engine is stopped, then `offlineDb.delete()` runs) and
 * during a cross-tab delete; callers treat it specially instead of surfacing it
 * as an unhandled rejection. Shared by the sync engine and the background write
 * helpers (eviction, on-demand) so the check stays consistent.
 */
export function isDbClosedError(err: unknown): boolean {
  if (!(err instanceof Error)) return false
  return (
    err.name === "DatabaseClosedError" || err.message.includes("DatabaseClosed")
  )
}
